const ALLOWED_BUSINESS_CATEGORY_ID = [
  51, // Retail - Apparel & Accessories
  67, // Retail - Baby
  68, // Retail - Electronics
  69, // Retail - Furniture, Home, & Garden
  70, // Retail - Health & Beauty
  63, // Retail - Other
  71, // Retail - F & B
];

const ALLOWED_EMAIL = [
  'mindoprod@mailinator.com',
  'hendri.antomy@mokapos.com',
  'mindosormin@mailinator.com',
  'dimass@mailinator.com',
  'product-moka@mailinator.com',
  'hiroo@mailinator.com',
  'ariestafarida@gmail.com',
  'shannonidol@gmail.com',
];

export { ALLOWED_BUSINESS_CATEGORY_ID, ALLOWED_EMAIL };
